import { HttpClient } from 'api/http-client';
import { Start } from 'api/notifications';
/** Per-notification read state from the API (source of truth for the unread dot). */ export var ForReviewItemStatus = /*#__PURE__*/ function(ForReviewItemStatus) {
    ForReviewItemStatus["New"] = "New";
    ForReviewItemStatus["Cleared"] = "Cleared";
    return ForReviewItemStatus;
}({});
/** List filter for `/notifications/groups`. */ export var ForReviewListStatus = /*#__PURE__*/ function(ForReviewListStatus) {
    ForReviewListStatus["New"] = "New";
    ForReviewListStatus["Cleared"] = "Cleared";
    ForReviewListStatus["All"] = "All";
    return ForReviewListStatus;
}({});
export var ForReviewType = /*#__PURE__*/ function(ForReviewType) {
    ForReviewType["Blocking"] = "BLOCKING";
    ForReviewType["Advisory"] = "ADVISORY";
    return ForReviewType;
}({});
export const isForReviewUnread = (item)=>item.status !== "Cleared";
class NitroReviewHttpClient extends HttpClient {
    getForReviewNotifications(params) {
        const { status = "All", count = 50, start = Start()[1] } = params !== null && params !== void 0 ? params : {};
        return this.get(`/notifications/groups?status=${status}&filter=NitroReview&count=${count}&start=${start}`);
    }
    clearForReviewItem(notificationId) {
        return this.patch(`/notifications/${notificationId}/clear`, {});
    }
    unclearForReviewItem(notificationId) {
        return this.patch(`/notifications/${notificationId}/unclear`, {});
    }
    getCheckpointMessage(referenceId, checkpointId) {
        return this.get(`/chat/conversations/${referenceId}/messages/${checkpointId}`);
    }
}
export const nitroReviewAPI = new NitroReviewHttpClient();
